import type { ZodInfer } from '@mntn-dev/utility-types'
import { EnumBuilder } from '@mntn-dev/utility-types'

export const [ChargeStates, ChargeStatusSchema] = EnumBuilder(
  'pending',
  'approved',
  'due',
  'overdue',
  'paid',
  'voided',
  'refunded',
  'processed'
)

export type ChargeStatus = ZodInfer<typeof ChargeStatusSchema>
